<template>
  <div id="item-table">
    <b-table
      :items="itemTable"
      :fields="fields"
      striped
      bordered
    >
      <template
        slot="รหัสสินค้า"
        slot-scope="data"
      >
        {{ data.item.item_code }}
      </template>
      <template
        slot="รายการสินค้า"
        slot-scope="data"
      >
        {{ data.item.item_name }}
      </template>
      <template
        slot="จำนวน"
        slot-scope="data"
      >
        {{ data.item.item_quantity }}
      </template>
      <template
        slot="ราคาต่อหน่วย"
        slot-scope="data"
      >
        {{ data.item.item_price }}
      </template>
      <template
        slot="ราคารวม"
        slot-scope="data"
      >
        {{ data.item.item_price * data.item.item_quantity }}
      </template>
      <template
        slot="ลบ"
        slot-scope="data"
      >
        <b-button
          variant="danger"
          @click="deleteItemHandler(data.index)"
        >
          ลบ
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
    name: "ItemTableOtherPlatformComponent",
    props: {
        itemTable: {
            type: Array
        },
        deleteItemHandler: {
            type: Function
        }
    },
    data() {
        return {
            fields: [
                "รหัสสินค้า",
                "รายการสินค้า",
                "จำนวน",
                "ราคาต่อหน่วย",
                "ราคารวม",
                "ลบ"
            ]
        }
    }
};
</script>

<style scoped></style>
